import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/core/service/utils.service';
import { ProjectSettingService, ConfigurationType } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';
import { DataService } from 'src/app/core/service/data.service';

@Component({
  selector: 'app-fee-modal',
  templateUrl: './fee-modal.component.html',
  styleUrls: ['./fee-modal.component.scss']
})
export class FeeModalComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  id: number | null = null;
  languages: any = [];
  tabs: number = 1;
  modalTitle: string;

  countries: any[] = [];
  feesForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;

  constructor(protected settingSrv: SettingsPageService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected dataSrv: DataService,
    public utilSrv: UtilsService) {
    this.countries = this.dataSrv.getCountryOptions();
  }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnDestroy(): void {
    this.id = null;
    this.languages = [];
    this.tabs = 1;
    this.modalTitle = '';
    this.submitted = false;
    this.loading = false;
  }

  get formFee() { return this.feesForm.controls; }

  setForm() {
    this.feesForm = this.fb.group({
      value: [null, Validators.required],
      name: [null, Validators.required],
      country: [null],
      countryName: [null],
    });
  }

  openModal(id?: number) {
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
    this.loading = true;
    this.setForm();

    if (id) {
      this.id = id;
      this.fillForm(id);
      this.modalTitle = this.translateService.instant('SETTINGS.FEES.EDIT');
    } else {
      this.modalTitle = this.translateService.instant('SETTINGS.FEES.ADD');
    }

    this.loading = false;
  }

  fillForm(id: number) {
    this.settingSrv.getFee(id).subscribe((response: any) => {
      this.feesForm.patchValue(response.data[0])
      this.loading = false;
    });
  }

  save() {
    this.submitted = true;
    if (this.feesForm.valid) {
      let request
      if (this.id) {
        request =this.settingSrv.updateFee(this.feesForm.value,this.id)
      } else request = this.settingSrv.registerFee(this.feesForm.value);
      request.pipe().subscribe((data: any) => {
        const successMsg = !this.id ? 'SETTINGS.CREATED' : 'SETTINGS.UPDATED';
        this.utilSrv.notify(successMsg, 'success').then(() => {
          this.updateTable.emit();
          this.closeModal();
        });
      }, (error: any) => {
        console.error('Save', error);
        this.utilSrv.notify('SETTINGS.ERROR', 'error');
      });
    }
  }

  setCountryName(){

    const countryName = this.countries.find((item)=> item.value === this.feesForm.value.country).label
    if(countryName){
      this.feesForm.patchValue({countryName:countryName})
    }
  }

  closeModal() { 
    this.tabs = 1;
    this.submitted = false;
    this.feesForm.reset();
    this.modalRef.close();
  }

}
